/*=== theme.js ===*/
/* NEUMAFLORES PRO - interacciones (v2). Mejora progresiva: si algo falla, el sitio sigue funcionando. */
(function(){
  'use strict';
  var d=document, b=document.body;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents){
    try{ return (cents/100).toLocaleString('es-AR',{style:'currency',currency:'ARS',minimumFractionDigits:2,maximumFractionDigits:2}); }
    catch(e){ return '$ '+(cents/100).toFixed(2); }
  }
  function on(el,ev,fn){ if(el) el.addEventListener(ev,fn); }

  /* header scroll state */
  var header=d.querySelector('.nf-header');
  function onScroll(){ if(header) header.classList.toggle('is-scrolled', window.scrollY>12); }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  /* reveal on scroll */
  var reveals=[].slice.call(d.querySelectorAll('[data-reveal]'));
  if(reveals.length){
    if(reduce || !('IntersectionObserver' in window)){ reveals.forEach(function(el){ el.classList.add('is-in'); }); }
    else{
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
      reveals.forEach(function(el,i){ el.style.transitionDelay=(Math.min(i%4,3)*70)+'ms'; io.observe(el); });
    }
  }

  /* count up stats */
  function countUp(el){
    var raw=el.getAttribute('data-count')||''; var target=parseFloat(raw.replace(/[^0-9.]/g,''))||0;
    var pre=el.getAttribute('data-pre')||''; var suf=el.getAttribute('data-suf')||'';
    if(reduce||target===0){ el.textContent=pre+raw+suf; return; }
    var start=null, dur=1100;
    function step(ts){ if(!start)start=ts; var p=Math.min((ts-start)/dur,1); var ease=1-Math.pow(1-p,3);
      el.textContent=pre+Math.round(target*ease).toLocaleString('es-AR')+suf; if(p<1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var stats=[].slice.call(d.querySelectorAll('[data-count]'));
  if(stats.length){
    if(!('IntersectionObserver' in window)){ stats.forEach(countUp); }
    else{ var io2=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ countUp(e.target); io2.unobserve(e.target); } }); },{threshold:0.5}); stats.forEach(function(s){ io2.observe(s); }); }
  }

  /* mobile menu */
  var menuTrigger=d.querySelector('[data-nf-burger]');
  var menuPanel=d.querySelector('[data-nf-mnav]');
  var menuClose=d.querySelector('[data-nf-mclose]');
  function setPanelState(panel,open){
    if(!panel) return;
    panel.setAttribute('aria-hidden',open?'false':'true');
    if(open) panel.removeAttribute('inert'); else panel.setAttribute('inert','');
  }
  function openM(){
    closeCart();
    b.classList.add('nf-mnav-open');
    if(menuTrigger) menuTrigger.setAttribute('aria-expanded','true');
    setPanelState(menuPanel,true);
    if(menuClose) menuClose.focus();
  }
  function closeM(){
    var wasOpen=b.classList.contains('nf-mnav-open');
    b.classList.remove('nf-mnav-open');
    if(menuTrigger) menuTrigger.setAttribute('aria-expanded','false');
    setPanelState(menuPanel,false);
    if(wasOpen && menuTrigger) menuTrigger.focus();
  }
  on(menuTrigger,'click',function(e){ e.preventDefault(); openM(); });
  on(menuClose,'click',closeM);
  on(d.querySelector('[data-nf-overlay]'),'click',function(){ closeM(); closeCart(); });
  function trapPanelFocus(panel,e){
    if(!panel || e.key!=='Tab') return;
    var focusable=[].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),details summary,[tabindex]:not([tabindex="-1"])'))
      .filter(function(el){ return !el.hasAttribute('inert') && el.offsetParent!==null; });
    if(!focusable.length){ e.preventDefault(); panel.focus(); return; }
    var first=focusable[0],last=focusable[focusable.length-1];
    if(e.shiftKey && d.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && d.activeElement===last){ e.preventDefault(); first.focus(); }
  }
  d.addEventListener('keydown',function(e){
    if(e.key==='Escape'){ closeM(); closeCart(); return; }
    if(b.classList.contains('nf-mnav-open')) trapPanelFocus(menuPanel,e);
    else if(b.classList.contains('nf-cart-open')) trapPanelFocus(cartPanel,e);
  });

  /* cart drawer */
  var ditems=d.querySelector('[data-nf-ditems]');
  var dtotal=d.querySelector('[data-nf-dtotal]');
  var cartPanel=d.querySelector('[data-nf-drawer]');
  var cartClose=d.querySelector('[data-nf-cclose]');
  var lastCartTrigger=null;
  function openCart(){
    closeM();
    lastCartTrigger=d.activeElement;
    b.classList.add('nf-cart-open');
    d.querySelectorAll('[data-nf-cart-open]').forEach(function(el){el.setAttribute('aria-expanded','true');});
    setPanelState(cartPanel,true);
    if(cartClose) cartClose.focus();
  }
  function closeCart(){
    var wasOpen=b.classList.contains('nf-cart-open');
    b.classList.remove('nf-cart-open');
    d.querySelectorAll('[data-nf-cart-open]').forEach(function(el){el.setAttribute('aria-expanded','false');});
    setPanelState(cartPanel,false);
    if(wasOpen && lastCartTrigger && lastCartTrigger.focus) lastCartTrigger.focus();
  }
  on(cartClose,'click',closeCart);

  function setCount(n){
    var cart=d.querySelector('.nf-cart'); if(!cart) return;
    var c=cart.querySelector('.count');
    if(n>0){ if(!c){ c=d.createElement('span'); c.className='count'; cart.appendChild(c); } c.textContent=n; }
    else if(c){ c.remove(); }
  }
  function renderCart(cart){
    if(!ditems) return;
    setCount(cart.item_count);
    if(dtotal) dtotal.textContent=money(cart.total_price);
    fetch('/?sections=nf-drawer-body',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(j){
      var h=j&&j['nf-drawer-body'];if(!h)throw new Error('sec');
      var tmp=d.createElement('div');tmp.innerHTML=h;
      var it=tmp.querySelector('.nfd-items'),tp=tmp.querySelector('[data-nfd-sumtpl]'),sm=d.querySelector('[data-nfd-sum]');
      ditems.innerHTML=it?it.outerHTML:'';if(sm)sm.innerHTML=tp?tp.innerHTML:'';
      b.classList.add('nfd-ok');b.classList.toggle('nfd-empty-cart',!cart.item_count);
    }).catch(function(){b.classList.remove('nfd-ok');legacyRender(cart);});
  }
  function legacyRender(cart){
    if(!ditems) return;
    setCount(cart.item_count);
    if(dtotal) dtotal.textContent=money(cart.total_price);
    if(!cart.items || !cart.items.length){ ditems.innerHTML='<div class="empty">Tu carrito está vacío.<br>Agregá productos para verlos acá.</div>'; return; }
    var html='';
    cart.items.forEach(function(it){
      var name=it.product_title||it.title;
      var vt=(it.variant_title && it.variant_title!=='Default Title')?('<div class="pr">'+it.variant_title+'</div>'):'';
      var img=it.image?('<img src="'+it.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_120x$1')+'" alt="">'):'';
      html+='<div class="nf-ditem" data-key="'+it.key+'"><div class="thumb">'+img+'</div><div class="info"><p class="nm">'+name+'</p>'+vt+'<div class="pr">'+money(it.price)+' c/u</div><div class="nf-qty" data-key="'+it.key+'"><button type="button" data-step="-1" aria-label="Restar">−</button><input type="number" min="0" value="'+it.quantity+'" data-line aria-label="Cantidad"><button type="button" data-step="1" aria-label="Sumar">+</button></div><button class="rm" type="button" data-rm="'+it.key+'">Quitar</button></div><div style="font-family:Saira Condensed,sans-serif;font-style:italic;font-weight:800;font-size:18px">'+money(it.line_price)+'</div></div>';
    });
    ditems.innerHTML=html;
  }
  function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function refresh(){ return getCart().then(renderCart).catch(function(){}); }
  function changeLine(key,qty){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }
  function addVariant(id,qty,btn,itemsPayload){
    if(btn){ btn.classList.add('loading'); btn.classList.add('is-adding'); btn.classList.remove('is-added'); }
    var payload;
    if(itemsPayload && Array.isArray(itemsPayload) && itemsPayload.length > 0){
      payload = { items: itemsPayload };
    } else {
      payload = { items: [{ id: parseInt(id,10), quantity: qty||1 }] };
    }
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ return refresh(); })
      .then(function(){
        if(btn){
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
          setTimeout(function(){ btn.classList.remove('is-added'); },1400);
        }
        openCart();
        var count = payload.items.length;
        toast(count > 1 ? 'Agregamos tus neumáticos y servicios al carrito' : ((qty||1)>1 ? ('Agregamos '+(qty||1)+' al carrito') : 'Agregado al carrito'));
      })
      .catch(function(){
        if(btn){ btn.classList.remove('is-adding'); btn.classList.remove('is-added'); }
        // If multi-item failed (e.g. pending CSV import in Shopify), fallback to main tire
        if(itemsPayload && itemsPayload.length > 1){
          return addVariant(id, qty, btn, null);
        }
        toast('No se pudo agregar. Probá de nuevo.');
      })
      .then(function(){ if(btn) btn.classList.remove('loading'); });
  }

  function paintQty(form, n){
    n=Math.max(1, parseInt(n,10)||1);
    var input=form.querySelector('[name="quantity"]');
    if(input && String(input.value)!==String(n)) input.value=n;
    form.querySelectorAll('[data-setq]').forEach(function(b){
      var on=String(b.getAttribute('data-setq'))===String(n);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var el=form.querySelector('[data-sum]');
    var unit=parseInt(form.getAttribute('data-unit'),10)||0;
    var cash=parseFloat(form.getAttribute('data-cash'))||0;
    if(el && unit){
      var line=n+' × '+money(unit);
      if(cash) line+=' · '+money(Math.round(cash*n))+' en efectivo billete';
      line+=' · 3 cuotas de '+money(unit*n/3);
      el.textContent=line;
    }
    var btn=form.querySelector('button[type="submit"]');
    if(btn){
      var span=btn.querySelector('span');
      var txt=n>1 ? ('Agregar '+n) : 'Agregar';
      if(span) span.textContent=txt;
      else if(!btn.querySelector('svg')) btn.textContent=txt;
    }
  }
  d.querySelectorAll('.nfc__form, .nfp__form').forEach(function(form){
    var input=form.querySelector('[name="quantity"]');
    paintQty(form, input ? input.value : 1);
  });
  d.addEventListener('click', function(e){
    var chip=e.target.closest && e.target.closest('[data-setq]');
    if(!chip) return;
    var form=chip.closest('form');
    if(!form || form.classList.contains('nfd__form')) return;
    e.preventDefault();
    paintQty(form, chip.getAttribute('data-setq'));
  });
  d.addEventListener('input', function(e){
    var input=e.target;
    if(!input.matches || !input.matches('.nfp__form [name="quantity"], .nfc__form [name="quantity"]')) return;
    var form=input.closest('form');
    if(form) paintQty(form, input.value);
  });
  d.addEventListener('submit', function(e){
    var form=e.target;
    if(!form.matches || !form.matches('.nfc__form, .nfp__form, .nfpro-card__form, .nfd__form')) return;
    e.preventDefault();
    var idEl=form.querySelector('[name="id"]');
    if(!idEl || !idEl.value) return;
    var checked=form.querySelector('[name="quantity"]:checked');
    var qtyEl=form.querySelector('[name="quantity"]');
    var qty=parseInt(checked ? checked.value : (qtyEl && qtyEl.value), 10) || 1;
    var items = [{ id: parseInt(idEl.value, 10), quantity: qty }];
    var activeSet = form.querySelector('[data-addon-set]:not([hidden])');
    if(activeSet){
      activeSet.querySelectorAll('[data-addon-input]:checked').forEach(function(cb){
        var vid = cb.getAttribute('data-addon-id');
        var aQty = parseInt(cb.getAttribute('data-addon-qty'), 10) || 1;
        if(vid && parseInt(vid, 10) > 0){
          items.push({ id: parseInt(vid, 10), quantity: aQty });
        }
      });
    }
    addVariant(idEl.value, qty, e.submitter || form.querySelector('[type="submit"]'), items.length > 1 ? items : null);
  });

  var cartBtns=[].slice.call(d.querySelectorAll('[data-nf-cart-open]'));
  cartBtns.forEach(function(btn){ on(btn,'click',function(e){ e.preventDefault(); openCart(); refresh(); }); });

  d.addEventListener('click',function(e){
    var add=e.target.closest && e.target.closest('[data-nf-add]');
    if(add){ e.preventDefault(); var vid=add.getAttribute('data-nf-add'); if(!vid) return; var qty=1; var pdp=add.closest('[data-nf-pdp]'); if(pdp){ var qi=pdp.querySelector('[data-nf-pqty]'); if(qi){ qty=Math.max(1,parseInt(qi.value,10)||1); } } addVariant(vid,qty,add); return; }
    var rm=e.target.closest && e.target.closest('[data-rm]');
    if(rm){ e.preventDefault(); changeLine(rm.getAttribute('data-rm'),0); return; }
    var stepBtn=e.target.closest && e.target.closest('.nf-qty button[data-step]');
    if(stepBtn){
      var wrap=stepBtn.closest('.nf-qty'); var input=wrap&&wrap.querySelector('input'); if(!input) return;
      var val=Math.max(0,(parseInt(input.value,10)||0)+parseInt(stepBtn.getAttribute('data-step'),10));
      input.value=val;
      if(input.hasAttribute('data-line')){ var key=wrap.getAttribute('data-key'); if(key) changeLine(key,val); }
      return;
    }
  });
  d.addEventListener('change',function(e){
    var input=e.target;
    if(input.matches && input.matches('.nf-qty input[data-line]')){
      var wrap=input.closest('.nf-qty'); var key=wrap&&wrap.getAttribute('data-key');
      if(key) changeLine(key,Math.max(0,parseInt(input.value,10)||0));
    }
  });

  /* toast */
  var toastEl;
  function toast(msg){
    if(!toastEl){ toastEl=d.querySelector('[data-nf-toast]'); }
    if(!toastEl){ toastEl=d.createElement('div'); toastEl.className='nf-toast'; toastEl.setAttribute('data-nf-toast',''); d.body.appendChild(toastEl); }
    toastEl.innerHTML='<span class="ck"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></span><span>'+msg+'</span>';
    toastEl.classList.add('show');
    clearTimeout(toastEl._t); toastEl._t=setTimeout(function(){ toastEl.classList.remove('show'); },2600);
  }

  /* measure finder (combina tipo + medida en q) */
  var finder=d.querySelector('.nf-finder');
  if(finder){
    finder.addEventListener('submit',function(){
      var g=function(id){ var el=d.getElementById(id); return el?el.value:''; };
      var an=g('nf-q-an'), pe=g('nf-q-pe'), ro=g('nf-q-ro');
      var tipoSel=d.getElementById('nf-q-tipo'); var tipo=tipoSel?tipoSel.value:'';
      var parts=[]; if(tipo) parts.push(tipo);
      var med=''; if(an) med+=an; if(pe) med+=(med?'/':'')+pe; if(ro) med+=' '+ro;
      if(med) parts.push(med.trim());
      if(tipoSel){ tipoSel.value=parts.join(' ').trim()||tipo; }
    });
  }

  /* product page: gallery + variants */
  var pdp=d.querySelector('[data-nf-pdp]');
  if(pdp){
    var mainImg=pdp.querySelector('[data-nf-main-img]');
    pdp.addEventListener('click',function(e){
      var th=e.target.closest && e.target.closest('[data-nf-thumb]');
      if(th && mainImg){
        var src=th.getAttribute('data-full');
        var srcset=th.getAttribute('data-srcset');
        var alt=th.getAttribute('data-alt');
        if(src){ mainImg.src=src; }
        if(srcset){ mainImg.srcset=srcset; } else { mainImg.removeAttribute('srcset'); }
        if(alt){ mainImg.alt=alt; }
        pdp.querySelectorAll('[data-nf-thumb]').forEach(function(x){x.classList.remove('active');x.setAttribute('aria-current','false');});
        th.classList.add('active');
        th.setAttribute('aria-current','true');
      }
    });
    var dataEl=pdp.querySelector('[data-nf-variants]'); var variants=[];
    if(dataEl){ try{ variants=JSON.parse(dataEl.textContent); }catch(e){} }
    var opts=[].slice.call(pdp.querySelectorAll('[data-nf-opt]'));
    var idInput=pdp.querySelector('[data-nf-id]');
    var priceNow=pdp.querySelector('[data-nf-now]');
    var priceWas=pdp.querySelector('[data-nf-was]');
    var addBtn=pdp.querySelector('[data-nf-buy]');
    var stockEl=pdp.querySelector('[data-nf-stock]');
    function selectedOpts(){ return opts.map(function(s){return s.value;}); }
    function matchVariant(){ var sel=selectedOpts(); return variants.filter(function(v){ return (v.options||[]).every(function(o,i){ return o===sel[i]; }); })[0]; }
    function updateVariant(){
      if(!variants.length) return; var v=matchVariant();
      if(!v){
        if(idInput) idInput.value='';
        if(priceWas) priceWas.style.display='none';
        if(stockEl) stockEl.innerHTML='<span class="nf-pdp-dot off" aria-hidden="true"></span>Combinación no disponible';
        if(addBtn){
          var missingLbl=addBtn.querySelector('.lbl');
          addBtn.setAttribute('disabled','disabled');
          addBtn.removeAttribute('data-nf-add');
          addBtn.removeAttribute('data-nf-addanim');
          if(missingLbl) missingLbl.textContent='Combinación no disponible';
        }
        return;
      }
      if(idInput) idInput.value=v.id;
      if(priceNow) priceNow.textContent=money(v.price);
      if(priceWas){ if(v.compare_at_price && v.compare_at_price>v.price){ priceWas.textContent=money(v.compare_at_price); priceWas.style.display=''; } else { priceWas.style.display='none'; } }
      if(addBtn){ var lbl=addBtn.querySelector('.lbl'); if(v.available){ addBtn.removeAttribute('disabled'); addBtn.setAttribute('data-nf-add',v.id); addBtn.setAttribute('data-nf-addanim',v.id); if(lbl) lbl.textContent='Agregar al carrito'; } else { addBtn.setAttribute('disabled','disabled'); addBtn.removeAttribute('data-nf-add'); addBtn.removeAttribute('data-nf-addanim'); if(lbl) lbl.textContent='Sin stock'; } }
    }
    opts.forEach(function(s){ on(s,'change',updateVariant); });
    updateVariant();
  }
})();

;
/*=== nf-boost.js ===*/
/* ===== NEUMAFLORES · boost: animaciones de aparición + performance ===== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1) PERFORMANCE: imágenes ---------- */
  function tuneImages() {
    var imgs = document.images, i, img, count = 0;
    for (i = 0; i < imgs.length; i++) {
      img = imgs[i];
      if (count < 2) {
        img.setAttribute('fetchpriority', 'high');
        if (!img.getAttribute('loading')) img.setAttribute('loading', 'eager');
      } else if (!img.getAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }
      if (!img.getAttribute('decoding')) img.setAttribute('decoding', 'async');
      if (!reduce && count >= 2 && !img.complete && !img.classList.contains('nfd__img') && !(img.closest && img.closest('.nfd__gal'))) {
        img.setAttribute('data-nf-fade', '');
        img.addEventListener('load', function () { this.classList.add('nf-loaded'); }, { once: true });
        img.addEventListener('error', function () { this.classList.add('nf-loaded'); }, { once: true });
      }
      count++;
    }
  }

  /* ---------- 2) ANIMACIONES: reveal on scroll ---------- */
  function tagReveal() {
    if (reduce) return;
    var sel = [
      '#MainContent > section',
      '#MainContent .shopify-section > *',
      '.nf-card',
      '#MainContent h1', '#MainContent h2',
      '.nf-grid > *'
    ];
    var nodes = document.querySelectorAll(sel.join(','));
    var vh = window.innerHeight || 800;
    nodes.forEach(function (el) {
      if (el.hasAttribute('data-nf-rv')) return;
      // Lo que ya se ve al cargar no se esconde (así aparece al instante, sobre todo en celular)
      if (el.getBoundingClientRect().top < vh) return;
      var p = el.parentElement, skip = false;
      while (p) { if (p.hasAttribute && p.hasAttribute('data-nf-rv')) { skip = true; break; } p = p.parentElement; }
      if (skip && !el.classList.contains('nf-card')) return;
      el.setAttribute('data-nf-rv', '');
    });
    document.querySelectorAll('.nf-grid').forEach(function (grid) {
      var kids = grid.querySelectorAll(':scope > [data-nf-rv]');
      kids.forEach(function (k, idx) { k.style.setProperty('--nf-d', Math.min(idx, 8) * 45 + 'ms'); });
    });
  }

  function observeReveal() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-nf-rv]');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('nf-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('nf-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    items.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < (window.innerHeight || 800)) el.classList.add('nf-in');
      else io.observe(el);
    });
    setTimeout(function () { items.forEach(function (el) { el.classList.add('nf-in'); }); }, 2500);
  }

  function init() {
    tuneImages();
    tagReveal();
    observeReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

;
/*=== nf-polish.js ===*/
/* ============================================================
   NEUMAFLORES · NF-POLISH JS — contadores + tilt sutil en glass
   + barra de progreso de scroll + ripple en botones.
   Vanilla, sin dependencias. Respeta prefers-reduced-motion.
   ============================================================ */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function fmt(n) {
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  /* ---------- Contadores de stats ([data-count]) ---------- */
  function initCounters() {
    var els = [].slice.call(document.querySelectorAll("[data-count]"));
    if (!els.length) return;
    function setFinal(el) {
      var n = parseFloat(el.getAttribute("data-count")) || 0;
      el.textContent = (el.getAttribute("data-pre") || "") + fmt(n) + (el.getAttribute("data-suf") || "");
    }
    if (reduce || !("IntersectionObserver" in window)) { els.forEach(setFinal); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; io.unobserve(el);
        if (el.__done) return; el.__done = true;
        var target = parseFloat(el.getAttribute("data-count")) || 0;
        var pre = el.getAttribute("data-pre") || "", suf = el.getAttribute("data-suf") || "";
        var t0 = null, DUR = 1400;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / DUR);
          var e = 1 - Math.pow(1 - p, 3); /* ease-out cubic */
          el.textContent = pre + fmt(target * e) + suf;
          if (p < 1) requestAnimationFrame(step); else el.textContent = pre + fmt(target) + suf;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Tilt sutil en tarjetas glass (solo mouse fino) ---------- */
  function initTilt() {
    if (reduce || !window.matchMedia("(pointer: fine)").matches) return;
    [].slice.call(document.querySelectorAll(".nf-glass")).forEach(function (card) {
      var raf = 0;
      card.addEventListener("mousemove", function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = card.getBoundingClientRect();
          var rx = ((e.clientY - r.top) / r.height - 0.5) * -3;
          var ry = ((e.clientX - r.left) / r.width - 0.5) * 3;
          card.style.transform = "perspective(700px) rotateX(" + rx.toFixed(2) + "deg) rotateY(" + ry.toFixed(2) + "deg) translateY(-2px)";
        });
      });
      card.addEventListener("mouseleave", function () {
        card.style.transition = "transform .45s ease";
        card.style.transform = "";
        setTimeout(function () { card.style.transition = ""; }, 460);
      });
    });
  }

  /* ---------- Barra de progreso de scroll (2px, amarilla, arriba de todo) ---------- */
  function initScrollProgress() {
    if (reduce) return; /* con reduced-motion ni se crea */
    if (document.getElementById("nf-scrollprog")) return;
    var bar = document.createElement("div");
    bar.id = "nf-scrollprog";
    bar.setAttribute("aria-hidden", "true");
    bar.style.cssText =
      "position:fixed;top:0;left:0;width:100%;height:2px;z-index:140;" +
      "background:var(--brand,#FFD400);transform-origin:0 50%;transform:scaleX(0);" +
      "pointer-events:none;";
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      ticking = false;
      var doc = document.documentElement;
      var max = (doc.scrollHeight || 0) - window.innerHeight;
      var p = max > 0 ? (window.scrollY || doc.scrollTop || 0) / max : 0;
      bar.style.transform = "scaleX(" + Math.min(1, Math.max(0, p)).toFixed(4) + ")";
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }

  /* ---------- Ripple sutil en .nf-btn / .nf-btn-wa (estilos en nf-system.css) ---------- */
  function initRipple() {
    if (reduce) return;
    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest(".nf-btn,.nf-btn-wa");
      if (!btn || btn.disabled) return;
      var r = btn.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (e.detail === 0) { x = r.width / 2; y = r.height / 2; } /* click por teclado */
      var dx = Math.max(x, r.width - x), dy = Math.max(y, r.height - y);
      var rad = Math.sqrt(dx * dx + dy * dy);
      var s = document.createElement("span");
      s.className = "nf-ripple";
      s.style.width = s.style.height = (rad * 2) + "px";
      s.style.left = (x - rad) + "px";
      s.style.top = (y - rad) + "px";
      btn.appendChild(s);
      setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 500);
    });
  }


  /* ---------- Neumático rodando en el botón de agregar al carrito ---------- */
  function initRollingTire() {
    var TIRE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="9.2"/><circle cx="12" cy="12" r="3.4"/>' +
      '<path d="M12 2.8v3M12 18.2v3M2.8 12h3M18.2 12h3M5.5 5.5l2.1 2.1M16.4 16.4l2.1 2.1M18.5 5.5l-2.1 2.1M7.6 16.4l-2.1 2.1"/></svg>';
    var CHECK = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

    function prep(btn) {
      if (btn.dataset.nfRollReady) return;
      btn.dataset.nfRollReady = "1";
      /* envolver el texto para poder atenuarlo */
      if (!btn.querySelector(".nf-lbl")) {
        var lbl = document.createElement("span");
        lbl.className = "nf-lbl";
        while (btn.firstChild) lbl.appendChild(btn.firstChild);
        btn.appendChild(lbl);
      }
      var roll = document.createElement("span"); roll.className = "nf-roll"; roll.innerHTML = TIRE;
      var track = document.createElement("span"); track.className = "nf-track";
      var done = document.createElement("span"); done.className = "nf-done";
      done.innerHTML = CHECK + "<span>Agregado</span>";
      btn.appendChild(track); btn.appendChild(roll); btn.appendChild(done);
    }

    document.querySelectorAll(".nf-btn[data-nf-addanim]").forEach(prep);

    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest(".nf-btn[data-nf-addanim]");
      if (!btn || btn.disabled || btn.classList.contains("is-adding")) return;
      prep(btn);
      if (reduce) return;
      /* distancia real: de borde a borde del botón */
      var w = btn.getBoundingClientRect().width;
      btn.style.setProperty("--nf-roll-x", Math.max(60, w - 44) + "px");
      btn.classList.remove("is-added");
      btn.classList.add("is-adding");
    }, true);
  }


  /* ---------- Partículas de marca en botones y accesos ---------- */
  function initParticles() {
    if (reduce) return;
    var SEL = ".nf-btn,.nf-btn-wa,.nf-btn-ghost,.nf-mayor,.nfp-hero__btn,.nfw-btn";
    var GREEN = ["#25D366", "#8DF0B4", "#EAFFF2"];
    var YELLOW = ["#FFD400", "#FFE97A", "#FFFFFF"];

    function layer(btn) {
      var l = btn.querySelector(":scope > .nf-parti");
      if (!l) { l = document.createElement("span"); l.className = "nf-parti"; btn.appendChild(l); }
      return l;
    }
    function palette(btn) {
      return (btn.classList.contains("nf-btn-wa") || btn.closest(".nf-wa-float")) ? GREEN : YELLOW;
    }
    function emit(btn, n, ox, oy, spread, up) {
      var l = layer(btn), pal = palette(btn), r = btn.getBoundingClientRect();
      for (var i = 0; i < n; i++) {
        var p = document.createElement("i");
        p.className = "nf-p";
        var px = ox == null ? Math.random() * r.width : ox + (Math.random() - .5) * 14;
        var py = oy == null ? r.height + 2 : oy;
        p.style.setProperty("--px", px.toFixed(1) + "px");
        p.style.setProperty("--py", py.toFixed(1) + "px");
        p.style.setProperty("--ps", (2 + Math.random() * 3.4).toFixed(1) + "px");
        p.style.setProperty("--pc", pal[(Math.random() * pal.length) | 0]);
        p.style.setProperty("--pdx", ((Math.random() - .5) * spread).toFixed(1) + "px");
        p.style.setProperty("--pdy", (-(up * (.55 + Math.random() * .8))).toFixed(1) + "px");
        p.style.setProperty("--pd", (620 + Math.random() * 520).toFixed(0) + "ms");
        p.style.setProperty("--pdl", (Math.random() * 130).toFixed(0) + "ms");
        p.style.setProperty("--pe", (.7 + Math.random() * .7).toFixed(2));
        l.appendChild(p);
        setTimeout(function (el) { return function () { if (el.parentNode) el.parentNode.removeChild(el); }; }(p), 1400);
      }
    }

    /* al pasar el mouse: chispas suaves subiendo desde la base */
    document.addEventListener("pointerenter", function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest(SEL);
      if (!btn || btn.disabled || btn.dataset.nfPHover === "1") return;
      btn.dataset.nfPHover = "1";
      emit(btn, 7, null, null, 26, 30);
      setTimeout(function () { delete btn.dataset.nfPHover; }, 520);
    }, true);

    /* al hacer clic: estallido desde el punto tocado */
    document.addEventListener("click", function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest(SEL);
      if (!btn || btn.disabled) return;
      var r = btn.getBoundingClientRect();
      var ox = e.detail === 0 ? r.width / 2 : e.clientX - r.left;
      var oy = e.detail === 0 ? r.height / 2 : e.clientY - r.top;
      emit(btn, 16, ox, oy, 90, 46);
    }, true);
  }

  function boot() { initCounters(); initTilt(); initScrollProgress(); initParticles(); initRollingTire(); }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
})();

;

